 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Add Entry~CreateCalendarEvent~CreateHighlights~Edit Entry~EditHighlights~View Entry":"Add Entry~CreateCalendarEvent~CreateHighlights~Edit Entry~EditHighlights~View Entry","Calendar~Categories~CreateCalendarEvent~Notification~Users~View Entry":"Calendar~Categories~CreateCalendarEvent~Notification~Users~View Entry","AddAutomation~Calendar~CalendarEvent~CreateCalendarEvent":"AddAutomation~Calendar~CalendarEvent~CreateCalendarEvent","CreateCalendarEvent":"CreateCalendarEvent","Edit Entry~View Entry":"Edit Entry~View Entry","View Entry":"View Entry","CreateHighlights":"CreateHighlights","EditHighlights":"EditHighlights","Add Entry":"Add Entry","Edit Entry":"Edit Entry","CalendarEvent":"CalendarEvent","AddAutomation":"AddAutomation","Notification":"Notification","Users":"Users","Calendar":"Calendar","Categories":"Categories","Highlights":"Highlights","MenuManager~Role":"MenuManager~Role","MenuManager":"MenuManager","Role":"Role","PageManager":"PageManager","PolicyHighlights":"PolicyHighlights","Projects":"Projects","ScriptManager":"ScriptManager","States":"States","Tags":"Tags"}[chunkId]||chunkId) + "." + {"Add Entry~CreateCalendarEvent~CreateHighlights~Edit Entry~EditHighlights~View Entry":"5cd336db","Calendar~Categories~CreateCalendarEvent~Notification~Users~View Entry":"68a693ae","AddAutomation~Calendar~CalendarEvent~CreateCalendarEvent":"381eaaec","chunk-150660b6":"dbe6fe42","CreateCalendarEvent":"d27b6ccb","chunk-6898c867":"520cd812","Edit Entry~View Entry":"65479ae7","View Entry":"833c811e","CreateHighlights":"228c4983","EditHighlights":"ddbacec4","Add Entry":"60566bad","Edit Entry":"91a0c7f3","CalendarEvent":"0e525c8e","AddAutomation":"41db35ed","Notification":"cc41b826","Users":"1de6f36e","Calendar":"7eaaf1b5","Categories":"31baf167","Highlights":"4f5bc057","MenuManager~Role":"14bc2965","MenuManager":"f4190794","Role":"f7a13522","PageManager":"bdb08a80","PolicyHighlights":"93f07a87","Projects":"fc117049","ScriptManager":"09c2976e","States":"3f526a94","Tags":"f46617f5","chunk-23ef3fc6":"d6a9ef6c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Add Entry~CreateCalendarEvent~CreateHighlights~Edit Entry~EditHighlights~View Entry":1,"chunk-150660b6":1,"CreateCalendarEvent":1,"Edit Entry~View Entry":1,"View Entry":1,"CreateHighlights":1,"EditHighlights":1,"Add Entry":1,"Edit Entry":1,"CalendarEvent":1,"AddAutomation":1,"Notification":1,"Users":1,"Calendar":1,"Categories":1,"Role":1,"chunk-23ef3fc6":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Add Entry~CreateCalendarEvent~CreateHighlights~Edit Entry~EditHighlights~View Entry":"Add Entry~CreateCalendarEvent~CreateHighlights~Edit Entry~EditHighlights~View Entry","Calendar~Categories~CreateCalendarEvent~Notification~Users~View Entry":"Calendar~Categories~CreateCalendarEvent~Notification~Users~View Entry","AddAutomation~Calendar~CalendarEvent~CreateCalendarEvent":"AddAutomation~Calendar~CalendarEvent~CreateCalendarEvent","CreateCalendarEvent":"CreateCalendarEvent","Edit Entry~View Entry":"Edit Entry~View Entry","View Entry":"View Entry","CreateHighlights":"CreateHighlights","EditHighlights":"EditHighlights","Add Entry":"Add Entry","Edit Entry":"Edit Entry","CalendarEvent":"CalendarEvent","AddAutomation":"AddAutomation","Notification":"Notification","Users":"Users","Calendar":"Calendar","Categories":"Categories","Highlights":"Highlights","MenuManager~Role":"MenuManager~Role","MenuManager":"MenuManager","Role":"Role","PageManager":"PageManager","PolicyHighlights":"PolicyHighlights","Projects":"Projects","ScriptManager":"ScriptManager","States":"States","Tags":"Tags"}[chunkId]||chunkId) + "." + {"Add Entry~CreateCalendarEvent~CreateHighlights~Edit Entry~EditHighlights~View Entry":"fdb7b56f","Calendar~Categories~CreateCalendarEvent~Notification~Users~View Entry":"31d6cfe0","AddAutomation~Calendar~CalendarEvent~CreateCalendarEvent":"31d6cfe0","chunk-150660b6":"c9126f35","CreateCalendarEvent":"e98eacff","chunk-6898c867":"31d6cfe0","Edit Entry~View Entry":"85c575b3","View Entry":"6d697ccf","CreateHighlights":"8f9eae1f","EditHighlights":"4134cab6","Add Entry":"74392fd7","Edit Entry":"4beba785","CalendarEvent":"c1796531","AddAutomation":"7c8b59b7","Notification":"8737b93a","Users":"53267e67","Calendar":"6e41dd3f","Categories":"996f919e","Highlights":"31d6cfe0","MenuManager~Role":"31d6cfe0","MenuManager":"31d6cfe0","Role":"b5f9f94e","PageManager":"31d6cfe0","PolicyHighlights":"31d6cfe0","Projects":"31d6cfe0","ScriptManager":"31d6cfe0","States":"31d6cfe0","Tags":"31d6cfe0","chunk-23ef3fc6":"b4749a3c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
